import React from "react";
import * as Option from "fp-ts/lib/Option";
import { CustomDynamicHero, ProgramDynamicHero } from "hero";
function isCompatible(homepage) {
    return (typeof homepage.dynamicHero !== "undefined" && homepage.dynamicHero !== null);
}
export var block = function (homepage) {
    if (!isCompatible(homepage))
        return Option.none;
    return Option.some({
        key: homepage.uuid,
        View: function () {
            switch (homepage.dynamicHero.type) {
                case "CustomDynamicHero":
                    return (React.createElement(CustomDynamicHero, { hero: homepage.dynamicHero, trackingEnabled: !homepage.fetchingData }));
                case "ProgramDynamicHero":
                    return (React.createElement(ProgramDynamicHero, { hero: homepage.dynamicHero, linkedTitle: true, trackingEnabled: !homepage.fetchingData }));
            }
        },
    });
};
